import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { LoadingIndicatorComponent } from '@components/indicator/loading-indicator.component';
import { Store } from '@ngrx/store';
import { jobListFetch, occupationsFetch } from '@pages/job-match/state/actions';
import { IAppState } from '@state/state/app.state';
import { Observable } from 'rxjs';

import { filter } from 'rxjs/operators';

import { AuthStore } from './_pages/auth/auth-store';

import { APP } from './app.constant';
import { LoadingService } from './core/loading/loading.service';
import { LocalStorageService } from './core/local-storage/local-storage.service';
import { NavigationService } from './core/navigation/navigation.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterModule, LoadingIndicatorComponent]
})
export class AppComponent implements OnInit {
  transparentHeader = false;

  get isLoading$(): Observable<boolean> {
    return this.loadingService.isLoading$;
  }

  private readonly authStore = inject(AuthStore);

  constructor(
    private readonly router: Router,
    private readonly localStorageService: LocalStorageService,
    private readonly navigationService: NavigationService,
    private readonly loadingService: LoadingService,
    private readonly store$: Store<IAppState>
  ) {}

  ngOnInit(): void {
    let previousPath = '';
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.transparentHeader = event.urlAfterRedirects === '/home';
      const currentPath = event.urlAfterRedirects.split('?')[0];
      if (currentPath !== previousPath) {
        window.scrollTo(0, 0);
      }
      previousPath = currentPath;
    });

    const jwt: string | null = this.localStorageService.getItem(APP.AUTH.INFOR);
    if (jwt) {
      this.authStore.setAuthInfo(jwt);
      this.authStore.fetchUserInfo();
    }

    this.navigationService.startSaveHistory();
    this.store$.dispatch(jobListFetch());
    this.store$.dispatch(occupationsFetch());
  }
}
